<template>
  <div class="face">
    <NavBar v-if="sourceIsH5" :narBarTitle="$t('我的电子钥匙')" />
    <div class="content">
      <div class="title">{{ $t('二维码有效期至') }}{{ day }}</div>
      <div class="qrcode" ref="qrCodeUrl"></div>
      <div class="list">
        <div class="nameList">
          {{ $t('通行门禁：') }}{{ accessDeviceNames }}
        </div>
        <div class="moreList" @click.stop="showMoreList">
          {{ $t('查看更多') }}
        </div>
      </div>
      <div class="save-box">
        <div class="save" @click.stop="toSave">{{ $t('生成二维码图片') }}</div>
        <div class="renovate" @click.stop="toRenovate">{{ $t('刷新') }}</div>
      </div>
    </div>
    <div class="contentHide" id="shareImg" ref="shareImgUrl">
      <!-- <div class="hideClose" @click.stop="clickeCancel">
            <img src="@/assets/images/close.png" alt="" />
          </div> -->
      <div class="hideTitle">{{ name }}{{ $t('的电子门钥匙') }}</div>
      <div class="hideDay">{{ $t('二维码有效期至') }}{{ day }}</div>
      <div class="qrcodeSmall" ref="qrCodeSmallUrl"></div>
      <div class="message">
        <img src="@/assets/images/warning.png" alt="" />
        <div class="messageInfo">
          {{ $t('请妥善保管您的电子钥匙，如有遗失请刷新您的二维码。') }}
        </div>
      </div>
    </div>
    <van-popup v-model="showMoreListModal" class="outsiderStyle">
      <div class="close" @click.stop="clickeCancel">
        <img src="@/assets/images/close.png" alt="" />
      </div>
      <div class="outsider-title">{{ $t('所有门禁') }}</div>
      <div class="cancel-box">
        {{ $t('通行门禁：') }}{{ accessDeviceNames }}
      </div>
    </van-popup>
    <div class="faceMask" v-show="showModal">
      <img
        src="@/assets/images/closeImg.png"
        alt=""
        @click.stop="clickeImgCancel"
        class="fixed-close"
      />
      <img :src="imageurl" class="fixed-img" v-if="isDom" />
      <div class="fixed-text">{{ $t('请长按并保存图片！') }}</div>
    </div>
  </div>
</template>
<script>
import NavBar from '@/components/navBar'
import Vue from 'vue'
import { Icon, Button, Toast, Loading, Dialog, Popup } from 'vant'
import { queryStaffToekn, refreshElectronicKey } from '@/services/api'
import H5Cropper from 'vue-cropper-h5'
import dayjs from 'dayjs'
import QRCode from 'qrcodejs2'
import html2canvas from 'html2canvas'
// import Base64 from 'js-base64'

Vue.use(H5Cropper)
Vue.use(Icon)
Vue.use(Button)
Vue.use(Toast)
Vue.use(Loading)
Vue.use(Dialog)
Vue.use(Popup)

export default {
  name: 'faceCollection',
  components: {
    NavBar,
  },
  data() {
    return {
      name: '',
      accessDeviceNames: '',
      electronicKey: '',
      sourceIsH5: true,
      day: '',
      showModal: false,
      showMoreListModal: false,
      imageurl: '',
      isDom: false,
    }
  },
  methods: {
    async fetchUserData() {
      let Base64 = require('js-base64').Base64
      let user = JSON.parse(localStorage.getItem('user'))
      this.name = user.name ? user.name : this.$t('您')
      const newUser = await queryStaffToekn({ token: user.token })
      if (newUser.accessDeviceNames) {
        this.accessDeviceNames = newUser.accessDeviceNames.join('、')
      }

      if (!newUser.electronicKey) {
        const newKey = await refreshElectronicKey({ token: user.token })
        this.electronicKey = newKey
        this.creatQrCode(newKey)
        this.day = dayjs(
          dayjs.unix(JSON.parse(Base64.decode(newKey)).exp)
        ).format(this.$t('MM月DD日'))
      } else {
        this.electronicKey = newUser.electronicKey
        this.creatQrCode(newUser.electronicKey)
        this.day = dayjs(
          dayjs.unix(JSON.parse(Base64.decode(newUser.electronicKey)).exp)
        ).format(this.$t('MM月DD日'))
      }
    },
    // getExpirationTime() {
    //   let day = dayjs().add(31, 'day').format('MM月DD日')
    //   this.day = day
    // },
    toSave() {
      this.showModal = true
      var that = this
      html2canvas(this.$refs.shareImgUrl, {
        allowTaint: true,
        useCORS: true,
        logging: true,
        taintTest: true,
        scale: 2,
        width: 294,
        height: 440,
      })
        .then((canvas) => {
          that.imageurl = canvas.toDataURL('image/png')
          that.isDom = true
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    async toRenovate() {
      let Base64 = require('js-base64').Base64
      let user = JSON.parse(localStorage.getItem('user'))
      const newKey = await refreshElectronicKey({ token: user.token })
      this.electronicKey = newKey
      this.creatQrCode(newKey)
      this.day = dayjs(
        dayjs.unix(JSON.parse(Base64.decode(newKey)).exp)
      ).format(this.$t('MM月DD日'))
    },
    creatQrCode(url) {
      this.$refs.qrCodeUrl.innerHTML = ''
      var qrcode = new QRCode(this.$refs.qrCodeUrl, {
        text: url,
        width: 240,
        height: 240,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H,
      })
      this.$refs.qrCodeSmallUrl.innerHTML = ''
      var qrcodeSmall = new QRCode(this.$refs.qrCodeSmallUrl, {
        text: url,
        width: 240,
        height: 240,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H,
      })
    },
    showMoreList() {
      this.showMoreListModal = true
    },
    clickeCancel() {
      this.showMoreListModal = false
    },
    clickeImgCancel() {
      this.showModal = false
    },
  },

  mounted() {
    this.fetchUserData()
    if (window.injectData && window.injectData.source == 'NewWorkApp') {
      this.sourceIsH5 = false
    }
  },
}
</script>
<style lang="less" scoped>
.face {
  height: 100%;
  background: #f9f9f9;
  padding-top: 1px;
  position: relative;
}
.content {
  height: 80%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.title {
  margin-top: 56px;
  margin-bottom: 24px;
  color: #096dd9;
  font-size: 18px;
  font-weight: 700;
}
.qrcode {
  margin-bottom: 35px;
}
.list {
  margin-bottom: 100px;
  padding: 0 38px;
  position: relative;
  width: 100%;
  .nameList {
    font-size: 16px;
    font-weight: 400;
    color: #333333;
    line-height: 24px;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    display: -webkit-box;
    /*! autoprefixer: off */
    -webkit-box-orient: vertical;
    /* autoprefixer: on */
    -webkit-line-clamp: 3;
    word-break: break-all;
  }
  .moreList {
    font-size: 16px;
    font-weight: 600;
    color: #009bff;
    line-height: 22px;
    position: absolute;
    right: 38px;
    bottom: -25px;
  }
}
.save-box {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.save {
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 160px;
  height: 44px;
  background: #009bff;
  border-radius: 24px;
  color: #ffffff;
  font-size: 16px;
  margin-right: 16px;
}

.renovate {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 160px;
  height: 44px;
  border-radius: 24px;
  border: 1px solid #009bff;
  color: #009bff;
  font-size: 16px;
}
.outsiderStyle {
  padding: 25px 17px 25px 25px;
  width: 296px;
  background: #ffffff;
  border-radius: 4px;
}
.outsider-title {
  font-size: 16px;
  font-weight: 400;
  color: #333333;
  line-height: 22px;
  margin-bottom: 12px;
  display: flex;
  justify-content: center;
}
.cancel-box {
  font-size: 16px;
  font-weight: 400;
  color: #333333;
  line-height: 24px;
}
.cancel-Mask {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 9999;
}
.close {
  position: absolute;
  top: 7px;
  right: 8px;
  z-index: 9999;
  width: 40px;
  height: 40px;

  img {
    width: 40px;
    height: 40px;
  }
}
.faceMask {
  position: absolute;
  z-index: 9999999;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
}
.contentHide {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 296px;
  height: 440px;
  background-color: #ffffff;
  position: absolute;
  z-index: -99999;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;

  .hideClose {
    margin-top: 8px;
    width: 100%;
    height: 30px;
    padding-right: 7px;
    display: flex;
    justify-content: flex-end;
    img {
      width: 30px;
      height: 30px;
    }
  }
  .hideTitle {
    margin-top: 30px;
    font-size: 24px;
    font-weight: 400;
    color: #333333;
    line-height: 33px;
    margin-bottom: 15px;
  }
  .hideDay {
    font-size: 14px;
    font-weight: 500;
    color: #096dd9;
    line-height: 24px;
    margin-bottom: 5px;
  }
  .qrcodeSmall {
    margin-bottom: 24px;
  }
  .message {
    width: 100%;
    padding: 0 28px;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 24px;
      height: 24px;
      margin-right: 6px;
    }
    .messageInfo {
      font-size: 13px;
      font-weight: 500;
      color: #ff1d00;
      line-height: 18px;
    }
  }
}
.fixed-close {
  width: 32px;
  height: 32px;
  position: absolute;
  top: 44px;
  right: 20px;
}
.fixed-img {
  width: 296px;
  height: 440px;
  margin-bottom: 15px;
}
.fixed-text {
  font-size: 16px;
  font-weight: 500;
  color: #ffffff;
  line-height: 24px;
}
</style>
